module.exports = __webpack_public_path__ + "media/application/images/svgs/social/twitter-17282e5ae8bd1da254cb1916a9acdaaa.svg";